import { getMobileDetect } from "@shared/index";
import Cookies from "js-cookie";
import { useEffect } from "react";
import { useTranslation } from "next-i18next";

  
export const useCurrencyRate = () => {
  
  var currencyDefault = 'EUR';
  const { t } = useTranslation();

  if(Cookies.get('currency') !== undefined)
    currencyDefault =  Cookies.get('currency')!.toString();
  else{
    
    currencyDefault = t("Currency");
  }

  const rate_EUR_GBP = 0.86;
  const rate_EUR_USD = 1.07;

  var price_rate = 1;
  var price_symbol = 'Є';


  if(currencyDefault == 'GBP')
  {
    price_rate =  rate_EUR_GBP;
    price_symbol = '£';
  }
  else if(currencyDefault == 'USD')
  {
    price_rate =  rate_EUR_USD;
    price_symbol = '$';
  }
   
 
  return {
    rate: price_rate,
    symbol: price_symbol
  }
};



